import React from 'react'
import {Modal, Typography, IconButton, Button} from '@material-ui/core'
import './Dialog.scss'

import CloseIcon from '@material-ui/icons/Close'

const RootClass = 'ap-res-dialog'

const DialogAlert = ({open = false, title, description, yesLabel, yesCallback, onClose}) => {
  return (
    <Modal
      style={{position: 'absolute'}}
      open={open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={`c-res-mod ${RootClass}`}>
        <div className={`${RootClass}__header`}>
          <div className="ap-modal__container ap-modal__container--column">
            <Typography className="ap-typography ap-typography--lg">{title}</Typography>
            <Typography className="ap-typography ap-typography-sm ap-typography--gray">
              {description}
            </Typography>
          </div>
          <IconButton onClick={onClose} style={{position: 'absolute', right: 12, top: 12}}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={`${RootClass}__footer`}>
          <div className={`${RootClass}__align ${RootClass}__align--right`}>
            <Button
              onClick={e => {
                yesCallback(e, onClose)
              }}
              style={{width: 96}}
              className="ap-button ap-button--primary"
            >
              {yesLabel}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default DialogAlert
